import type { AbstractControl } from '@angular/forms';

export type ValidationMessageOverrides = Record<string, string>;

export function shouldShowValidationError(
  control: AbstractControl | null | undefined,
  submitted = false,
): boolean {
  return Boolean(control?.invalid && (control.touched || submitted));
}

export function getValidationMessage(
  control: AbstractControl | null | undefined,
  overrides: ValidationMessageOverrides = {},
): string {
  if (!control?.errors) return '';
  const errors = control.errors;
  const firstKey = Object.keys(errors)[0];
  if (!firstKey) return '';
  if (overrides[firstKey]) return overrides[firstKey];
  if (firstKey === 'required') return 'This field is required.';
  if (firstKey === 'email') return 'Enter a valid email address.';
  if (firstKey === 'minlength')
    return `Use at least ${errors[firstKey].requiredLength} characters.`;
  if (firstKey === 'maxlength')
    return `Use no more than ${errors[firstKey].requiredLength} characters.`;
  if (firstKey === 'pattern') return 'Use the requested format.';
  if (firstKey === 'invalidPhone') return 'Enter a valid phone number.';
  if (firstKey === 'weakPassword')
    return 'Use 8–20 characters with an uppercase letter, number, and symbol.';
  if (firstKey === 'passwordMismatch') return 'Passwords do not match.';
  return 'Enter a valid value.';
}
